import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store' // 导入 store
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Courses from "../views/Courses.vue";
import News from "../views/News.vue";
import Contact from "../views/Contact.vue";
import dynamics from "../views/dynamics.vue";
import details from "../views/details.vue";
import notice from "../views/notice.vue";
import Institute from "../views/Institute.vue";
import Project from "../views/Project.vue";
import Volume from "../views/Volume.vue";
import Policy from "../views/Policy.vue";
import Talent from "../views/Talent.vue";
import ExpertDetail from "../views/ExpertDetail.vue";
import JobDetail from "../views/JobDetail.vue";
import PurchasedCourse from "../views/user/PurchasedCourse.vue";
import GradeQuery from "../views/user/GradeQuery.vue";
import ECertificate from "../views/user/ECertificate.vue";
import Profile from "../views/user/Profile.vue";
import StudyCourse from "../views/user/StudyCourse.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/courses",
    name: "Courses",
    component: Courses,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/dynamics",
    name: "dynamics",
    component: dynamics,
  },
  {
    path: "/notices",
    name: "notices",
    component: notice,
  },
  {
    path: "/details",
    name: "details",
    component: details,
  },
  {
    path: "/ProjectDetails",
    name: "ProjectDetails",
    component: () => import('@/views/ProjectDetails.vue'),
  },
  {
    path: "/institute",
    name: "Institute",
    component: Institute,
  },
  {
    path: "/project",
    name: "Project",
    component: Project,
  },
  {
    path: "/volume",
    name: "Volume",
    component: Volume,
  },
  {
    path: "/policy",
    name: "PolicyPage",
    component: Policy,
  },
  {
    path: "/talent",
    name: "Talent",
    component: Talent,
  },
  {
    path: "/expert-detail",
    name: "ExpertDetail",
    component: ExpertDetail,
  },
  {
    path: "/course-resource-detail",
    name: "CourseResourceDetail",
    component: () => import('@/views/CourseResourceDetail.vue'),
  },
  {
    path: "/job/:id",
    name: "JobDetail",
    component: JobDetail,
  },
  {
    path: "/archive-course",
    name: "ArchiveCourse",
    component: () => import('@/views/user/ArchiveCourse.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/purchased-course",
    name: "PurchasedCourse",
    component: PurchasedCourse,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/grade-query",
    name: "GradeQuery",
    component: GradeQuery,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/e-certificate",
    name: "ECertificate",
    component: ECertificate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/course-detail/:type/:id',
    name: 'CourseDetail',
    component: () => import('@/views/user/CourseDetail.vue')
  },
  {
    path: '/home/studyCourse',
    name: 'StudyCourse',
    component: StudyCourse,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/exam',
    name: 'ExamPage',
    component: () => import('@/views/exam/ExamPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/practice',
    name: 'PracticePage',
    component: () => import('@/views/exam/PracticePage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/home/videoPlayer',
    name: 'VideoPlayer',
    component: () => import('@/views/user/VideoPlayer.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mall',
    name: 'Mall',
    component: () => import('@/views/Mall.vue')
  },
  {
    path: '/mall/product/:id',
    name: 'MallProduct',
    component: () => import('@/views/MallProduct.vue')
  },
  {
    path: '/mall/cart',
    name: 'MallCart',
    component: () => import('@/views/MallCart.vue')
  },
  {
    path: '/mall/orders',
    name: 'MallOrders',
    component: () => import('@/views/MallOrders.vue')
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.isLoggedIn;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;